<template>
  <div class="main-layout">
    <div class="bottom-text">{{textLine1}}
        <a href="https://beian.miit.gov.cn/" target="_blank"  style="cursor:pointer;color:#ffffff">京ICP备15009692号-1</a>
    </div>
    <div class="bottom-text">{{textLine2}}</div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        textLine1: '版权所有 复制必究  未经书面授权禁止使用  ',
        textLine2: '主办单位：北京市专业气象台  北京市气象局 ▪ 北京万云易博达信息技术有限公司 (010) 68400770/71-8030/8053',
      }
    },
    mounted: function () {
    },
    created: function () {
    },
    methods: {}
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .main-layout {
    display block;
    background-image url("../assets/image/bjqx_web_bottom.png")
    /*height 60px;
    background-repeat no-repeat;*/
    padding 5px;
  }

  .bottom-text {
    color #ffffff;
    line-height 25px;
    height 25px;
    text-align center;
    font-size 14px;
  }
</style>
